/**
 * The temperature type for storing performance data and splitters. This is a
 * legacy value, in future use TemperatureType from PPC.
 */
export enum LegacyPerfSplitTemperatureType {
    DryBulb = "dry",
    WetBulb = "wet",
}